// extracted by mini-css-extract-plugin
module.exports = {"labelWrapper":"InputTextarea--labelWrapper","label":"InputTextarea--label","textarea":"InputTextarea--textarea","error":"InputTextarea--error"};